import util from './util';
import Data from './data';
import signLog from '../components/sign-log';
import { popMgr } from '../components/global';
// import chat from '../components/chat';

const ENABLE_DYNAMIC_REGISTER = 'enableDynamicRegister';
const FIRST_PAGE = 'source';
const VIEW_COUNT = 'view_count';
const EXPIRES = 1;
const AUTOPOPUP_CONFIG = 'autopopup';
const WHITE_PAGEKEY = [
    'evaluation',
    'evaluation-seller',
    'seller-evaluation',
    'lead-generation',
    'sell',
    'seller-tips',
    'successful-activation',
    'he-home',
    'schedule_meeting_link',
    'meeting'
];
const WHITE_PATHNAME = [
    '/listing-for-cms',
    '/listing-for-cms-snapshot',
    '/site/privacy-terms'
];
let TIMEOUT_QUEUE = [];
// the pages need popup agreement pop
const AGREEMENT_LISTING_PAGES = ['sold-listing', 'listing'];
const AGREEMENT_LISTING_DETAIL_PAGES = [
    'listing-detail',
    'listing-detail-sold'
];
const HAS_POP_AGREEMENT = '_PopupAgreement';

// 有缓存有landingpage规则就用landingpage的规则
const getAutoPopOptions = (isLandingPage, options) => {
    // record the first page , to trigger its autopopup
    let firstPageView = util.getCookie(FIRST_PAGE),
        lp_name = `lp=${window.location.pathname}`;
    if (isLandingPage) {
        util.setStorageItem(
            'localStorage',
            AUTOPOPUP_CONFIG,
            JSON.stringify(options)
        );
        if (firstPageView !== lp_name) {
            // use new lp rule
            util.setCookie(FIRST_PAGE, lp_name, EXPIRES);
            util.setCookie(VIEW_COUNT, 0, EXPIRES);
        }

        // 如果lp配置了dynamicRegister就写入cookie,不存在dynamicRegister配置就重置
        util.setCookie(
            ENABLE_DYNAMIC_REGISTER,
            Data.registration?.autopopup?.isDynamicRegister ? 1 : 0,
            EXPIRES
        );

        return options;
    }
    if (firstPageView) {
        // use lp rule
        return JSON.parse(
            util.getStorageItem('localStorage', AUTOPOPUP_CONFIG) || '{}'
        );
    }
    return options;
};
// 是否需要弹框
const tool = {
    passLandingPage() {
        return util.getCookie(FIRST_PAGE);
    },
    isInPages(pages, pathName) {
        let pageArr = [];
        if (pages) {
            //由于后台传递出来的字符串经过修改变为了json字符串，但是防止原始数据格式错误
            try {
                pageArr = JSON.parse(pages);
            } catch (e) {
                //这里为了避免url中带有逗号的情况被分隔
                pageArr = pages
                    .split(',/')
                    .map((link, index) => (index ? '/' : '') + link);
            }
        }

        for (let i = 0, len = pageArr.length; i < len; i++) {
            let pageItem = pageArr[i];
            const detailReg = /:[^/]+/;
            // 兼容/agent/{fullname}/:id
            if (pageItem === '/agent/detail/:id') {
                pageItem = '/agent/:detail/:id';
            }
            if (detailReg.test(pageItem)) {
                const pageReg = new RegExp(
                    pageItem
                        .replace(/:id/g, '\\d+')
                        .replace(/:[^/]+/g, '[^/]+') + '$'
                );
                if (pageReg.test(pathName)) {
                    return true;
                }
            }
            if (pageItem === pathName) {
                return true;
            }
        }
        return false;
    },
    isListingPage() {
        return ['listing', 'sold-listing'].includes(Data.pageKey);
    },
    isDetailPage() {
        return ['listing-detail', 'listing-detail-sold'].includes(Data.pageKey);
    },
    isAdCreate() {
        return Data.creatorId == -9;
    },
    isAdSource() {
        return (
            util.getCookie('_ads_source') || util.getQueryField('x_ads_source')
        );
    },
    isCurrentPage() {
        let firstPageView = util.getCookie(FIRST_PAGE),
            lp_name = `lp=${window.location.pathname}`;
        return firstPageView == lp_name;
    }
};

const isInNeedPopupPage = (triggerType, pageType, pages) => {
    switch (triggerType) {
        case 0:
            // 0: Selected Pages
            // 排除 pageArr的页面
            return !tool.isInPages(pages, window.location.pathname);
        case 1:
            //1: Only Listing detail pages
            return tool.isDetailPage();
        // 3 || 4: Landing Pages or HE 通过type判断是否弹窗，不通过triggerType
        case 3:
            //pageType是landingPage专有
            if (pageType == 2) {
                //Never Require Registration
                return false;
            }
            if (pageType == 1) {
                // Detail
                return tool.isDetailPage();
            }
            if (pageType == 5) {
                // Current Page -> Listing
                return tool.isCurrentPage();
            }
            return true;
        case 4:
            return true;
        default:
            //2:Never Trigger Registration Popup
            return false;
    }
};
// 是否在白名单
const isInWhiteList = () => {
    let isInPageKeys = WHITE_PAGEKEY.includes(Data.pageKey),
        isInPathname = WHITE_PATHNAME.includes(window.location.pathname),
        isPopup =
            util.getQueryField('isPopup') === '0' ||
            util.getCookie('_isPopup') === 'false';
    return isInPageKeys || isInPathname || isPopup;
};
//register/login automatic poping up
const onAutoPopup = (vm, options) => {
    // everytime open new page or reload clearTimeout
    clearTimeQueue();
    if (isInWhiteList()) {
        // if this page is in whitelist, clear all the timeout and dont't pop up;
        return false;
    }

    if (window.sitePrepareData && window.sitePrepareData()._disableAutoPopup) {
        return false;
    }

    const isAdSource = tool.isAdSource();
    //landingPage + IDX（非广告来源）走配置
    if (!Data.isLandingPage && isAdSource) {
        if (tool.isDetailPage()) {
            // 广告参数优先级最高
            vm.openSignLog({
                allowClose: false
            });
            // chat.openAIChat 已经被注释，无意义
            // !util.isMobile && chat.openAIChat();
            return true;
        }

        if (tool.isListingPage() && !tool.passLandingPage()) {
            // 广告参数在列表页不弹框
            return;
        }
    }
    let {
        type,
        delay,
        click,
        triggerType,
        pageType,
        pages,
        closeCallback,
        allowClose
    } = getAutoPopOptions(Data.isLandingPage, options);
    type = parseInt(type);
    if (!type) {
        return false;
    }
    triggerType = parseInt(triggerType);
    let flag = isInNeedPopupPage(triggerType, pageType, pages);
    if (!flag) {
        return false;
    }
    const count = parseInt(util.getCookie(VIEW_COUNT)) || 0;
    util.setCookie(VIEW_COUNT, count + 1, EXPIRES);

    allowClose =
        !isAdSource &&
        (allowClose === undefined ? Data.registration?.allowClose : allowClose); // 兼容存量数据，新量站自动弹框可关闭按钮放在autopopup里
    // 如果选择了Listing detail pages，则已售详情页固定3s后弹框
    if (triggerType === 1 && Data.pageKey === 'listing-detail-sold') {
        let timeId = setTimeout(() => {
            vm.openSignLog({ allowClose });
        }, 3000);
        TIMEOUT_QUEUE.push(timeId);
        return true;
    }
    const popSignLogin = () => {
        vm.openSignLog({
            allowClose,
            onClose: closeCallback,
            onsuccess: closeCallback,
            questionMsg:
                triggerType === 4 ? vm.$t('common:register.questionMsg') : ''
        });
    };
    // page views
    if (type === 1) {
        click = parseInt(click) || 0;
        if (click <= count + 1) {
            popSignLogin();
        }
    }
    // browing time
    if (type === 2) {
        delay = parseInt(delay) || 0;
        let timeId = setTimeout(() => {
            if (popMgr.getVisibleLength() > 0) {
                // 这个弹窗需要判断当前是否本来就已经打开了弹窗，然后就不弹了。
                return;
            }
            popSignLogin();
        }, delay * 1000);
        TIMEOUT_QUEUE.push(timeId);
    }
    return flag;
};
export const clearTimeQueue = () => {
    if (TIMEOUT_QUEUE.length > 0) {
        TIMEOUT_QUEUE.forEach(timeId => {
            clearTimeout(timeId);
        });
        TIMEOUT_QUEUE = [];
    }
};

// get agreement popup's title and content by mlsOrg.
export const getAgreementTitleContent = (
    mlsOrgs = [],
    pageKey = '',
    pageData = {}
) => {
    let hasPopAgreement = util.getStorageItem(
        'localStorage',
        HAS_POP_AGREEMENT
    );
    if (hasPopAgreement || mlsOrgs.length === 0) {
        return false;
    }
    if (AGREEMENT_LISTING_PAGES.includes(pageKey)) {
        for (let mls of mlsOrgs) {
            let title = mls.popUpTitle,
                content = mls.popUpContent;
            if (title || content) {
                return { title, content };
            }
        }
    }
    if (AGREEMENT_LISTING_DETAIL_PAGES.includes(pageKey)) {
        // TODO：house detail mlsOrg
        let module = pageData.modules.find(m => m.name === 'md-detail-info');
        let mlsOrgId;
        try {
            mlsOrgId = module && module.data.listingDetail.info.mlsOrgId;
        } catch {
            console.log("error: house's detail info is empty.");
        }
        if (mlsOrgId) {
            let mls = mlsOrgs.find(m => m.id == mlsOrgId),
                title = mls && mls.popUpTitle,
                content = mls && mls.popUpContent;
            if (title || content) {
                return { title, content };
            }
        }
    }
    return false;
};
// 在注册框输入已注册邮箱，自动弹出登录框
export const openLoginHideOtherPop = (vm, options = {}, email = '') => {
    let cur = popMgr.getCurrent();
    // 已经打开过登录框就直接退出。
    if (cur && cur.name === 'sign-log' && cur.type === 'login') {
        return;
    }
    options = Object.assign({}, Data.registration, options);
    let style = Data.registration && Data.registration.style;
    // if login successfully
    if (!options.hasOwnProperty('onsuccess')) {
        options.onsuccess = function () {
            popMgr.closeAllPopWin();
            // cur.destroy(false); //close current register popup
        };
    } else {
        let oldOnSuccess = options.onsuccess;
        options.onsuccess = function () {
            oldOnSuccess.call(oldOnSuccess);
            popMgr.closeAllPopWin();
            // cur.destroy(false); //close current register popup
        };
    }
    if (!options.hasOwnProperty('defaultEmail')) {
        options.defaultEmail = email;
    }
    //'hideOtherPop': if click close icon, should show the previous popup;
    return signLog.login(vm, options, style, true, 'hideOtherPop');
};
export default onAutoPopup;
